import React, { memo, forwardRef, useMemo, Fragment, useCallback } from 'react';
import { createUseStyles, Badge, Link } from 'hoi-poi-ui';
import { useWeb5Context } from "../../../../lib/Web5Context";
import { MATCHING_VALUES } from "../../constants";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'StatusFormatter');
const StatusFormatter = (_ref, ref) => {
  let {
    getTableSchemaRef,
    onEdit,
    data,
    node,
    api,
    syncNames,
    setIsInvalid,
    controlOpenedMatchingModal
  } = _ref;
  const classes = useStyles();
  const {
    t
  } = useWeb5Context();
  const onEditField = useCallback(() => {
    onEdit(data, node, api);
  }, [api, data, node, onEdit]);
  const badge = useMemo(() => {
    var _tableSchema$data$nam;
    const hasExtraInfo = data.extraInfo && Object.keys(data.extraInfo).length;
    const tableSchema = getTableSchemaRef();
    const isValuelist = (tableSchema === null || tableSchema === void 0 ? void 0 : (_tableSchema$data$nam = tableSchema[data.nameField]) === null || _tableSchema$data$nam === void 0 ? void 0 : _tableSchema$data$nam.type) === 101;
    if (syncNames.includes(data.nameField)) {
      return /*#__PURE__*/React.createElement(Badge, null, t('cfm_label_import_identifier'));
    } else if (!data.nameField) {
      return /*#__PURE__*/React.createElement(Badge, null, t('cfm_label_values_wont_imported'));
    } else if (data.nameField && !hasExtraInfo && isValuelist) {
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Badge, {
        type: "warn"
      }, t('cfm_label_pending_to_match')));
    } else if (data.nameField && !hasExtraInfo) {
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Badge, {
        type: "success"
      }, t('cfm_label_values_matched')));
    } else if (data.nameField && hasExtraInfo) {
      const notMatched = Object.keys(data.extraInfo).find(key => data.extraInfo[key] === MATCHING_VALUES.noValue || !controlOpenedMatchingModal[data.name] && data.extraInfo[key] === MATCHING_VALUES.creatAsNew);
      if (notMatched) {
        setIsInvalid && setIsInvalid(true);
        return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Badge, {
          type: "error"
        }, t('cfm_label_values_not_matched')), /*#__PURE__*/React.createElement(Link, {
          className: classes.editLink,
          onClick: onEditField
        }, t('cfm_action_values_edit')));
      } else {
        return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Badge, {
          type: "success"
        }, t('cfm_label_values_matched')), /*#__PURE__*/React.createElement(Link, {
          className: classes.editLink,
          onClick: onEditField
        }, t('cfm_action_values_edit')));
      }
    }
  }, [classes.editLink, data, onEditField, setIsInvalid, syncNames, t, getTableSchemaRef, controlOpenedMatchingModal]);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: classes.statusField
  }, badge);
};
export default /*#__PURE__*/memo(/*#__PURE__*/forwardRef(StatusFormatter));